import { RxUtil } from '@commons/util/utilities/rx';
import { IPromise, IQService } from 'angular';
import { Observable } from 'rxjs';

import { RecordEntry, RecordEntryService, RecordService } from '@contact/upgrade';

const MODULE_NAME = 'recordDeprecatedService';

/**
 * available methods in record service
 * @deprecated
 */
export interface IRecordDeprecatedService {
  /**
   * @deprecated
   */
  askToDeleteRecord(recordUuid: string, csrComment: string, csrUuid: string): IPromise<string>;
  /**
   * @deprecated
   */
  askToPreventRecord(responseId: string, csrComment: string, csrUuid: string): IPromise<string>;
  /**
   * @deprecated
   */
  searchOnRecords(): IPromise<RecordEntry[]>;
  /**
   * @deprecated
   */
  getRecordStatus(technicalId: string): IPromise<string>;
  /**
   * @deprecated
   */
  getRecordStreamUrl(): Observable<string>;
  /**
   * @deprecated
   */
  getRecordDownloadUrl(): Observable<string>;
}

/**
 * @deprecated
 */
export class RecordDeprecatedService implements IRecordDeprecatedService {
  static $inject: Array<string> = ['$q', 'recordService', 'recordEntryService'];

  public name = MODULE_NAME;

  constructor(
    private readonly $q: IQService,
    private readonly recordService: RecordService,
    private readonly recordEntryService: RecordEntryService
  ) {}

  /**
   * @deprecated
   */
  askToDeleteRecord(recordUuid: string, csrComment: string): IPromise<string> {
    return RxUtil.toPromise(this.recordService.askToDelete(recordUuid, csrComment), this.$q);
  }

  /**
   * @deprecated
   */
  askToPreventRecord(responseId: string, csrComment: string): IPromise<string> {
    return RxUtil.toPromise(this.recordService.askToPrevent(responseId, csrComment), this.$q);
  }

  /**
   * Returns the records of the specified agent
   * @deprecated
   */
  searchOnRecords(): IPromise<RecordEntry[]> {
    return RxUtil.toPromise(this.recordEntryService.getOnce(), this.$q);
  }

  /**
   * Return the record status (AVAILABLE, NOT_EXIST ...)
   * @deprecated
   */
  getRecordStatus(technicalId: string): IPromise<string> {
    return RxUtil.toPromise(this.recordService.getStatus(technicalId), this.$q);
  }

  /**
   * @returns the record stream url
   * @deprecated
   */
  getRecordStreamUrl(): Observable<string> {
    return this.recordService.getRecordStreamUrl();
  }

  /**
   * @returns the record download url
   * @deprecated
   */
  getRecordDownloadUrl(): Observable<string> {
    return this.recordService.getRecordDownloadUrl();
  }
}

export default MODULE_NAME;
